import { render } from "./BTooltip.vue?vue&type=template&id=08ac9c5c&ts=true"
import script from "./BTooltip.vue?vue&type=script&lang=ts"
export * from "./BTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/malo/Documents/lamasign/be-right-vue3-lib 15.25.31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__